import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmComponent } from './confirm.component';
import { UiMessageModule } from '@netfoundry-ui/ui/message';

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, MatDialogModule, UiMessageModule],
    declarations: [ConfirmComponent],
    exports: [ConfirmComponent],
})
export class UiConfirmModule {}
